module.exports = __webpack_public_path__ + "static/media/icon_suita_no_image.9c6592af.jpg";